import { Link } from "react-router-dom";
import { adresCwiczenia, type CwiczenieUzytkownika } from "../../lib/wynikUzytkownika.js";
import { IconCwiczenia } from "../icons/index.js";
import { Badge } from "../ui/Badge.js";
import { Card } from "../ui/Card.js";

/**
 * "Ćwiczenie dla Ciebie": jedno cwiczenie z metodyki dla parametru, w ktorym jest co poprawiac (staly tekst, bez
 * udzialu modelu), i przycisk "Poćwicz teraz", ktory zaklada trening na tym cwiczeniu (/cwiczenia?parametr=...).
 *
 * "Poćwicz teraz" to link wygladajacy jak przycisk primary (B-1): to nawigacja do innego ekranu, a nie akcja na tej
 * stronie. Jest jedynym primary w swojej grupie (B-2).
 */
export function KartaCwiczenia({
  cwiczenie,
  zrodloAnalizyId,
}: {
  cwiczenie: CwiczenieUzytkownika;
  zrodloAnalizyId: string;
}): React.JSX.Element {
  const { cwiczenie: c, indeks, dlaObszaruDoPoprawy } = cwiczenie;
  return (
    <section aria-labelledby="wynik-cwiczenie-naglowek">
      <h2 className="wynik-sekcja" id="wynik-cwiczenie-naglowek">
        <span className="wynik-sekcja__znak" aria-hidden="true">
          <IconCwiczenia size={20} />
        </span>
        Ćwiczenie dla Ciebie
      </h2>
      <Card>
        <div className="wynik-cwiczenie">
          <div className="wynik-cwiczenie__tekst">
            <p>
              <Badge>{c.tytul}</Badge>
            </p>
            <p className="wynik-cwiczenie__zadanie">{c.tekst}</p>
            {dlaObszaruDoPoprawy && <p className="wynik-uwaga">To obszar, w którym w tej rozmowie jest najwięcej do poprawy.</p>}
          </div>
          <Link className="btn btn--primary" to={adresCwiczenia(c.slug, indeks, zrodloAnalizyId)}>
            Poćwicz teraz
          </Link>
        </div>
      </Card>
    </section>
  );
}
